module.exports = __webpack_public_path__ + "img/dna-sao-paulo.647c11d1.jpg";